<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import getCookie from "./utils/cookie";

export default {
  name: 'App',
  created() {
    const token = getCookie('_token');
    const myUrl = encodeURIComponent(location.href);
    if (!token){
      location.href = `${window.CONFIG.loginUrl}?forward=${myUrl}`
      // window.open(loginUrl)
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
